import styled from "styled-components";
import { Mail } from "lucide-react";

export const PlanCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
  font-family: "Geist", sans-serif;

  .plan-card-row {
    gap: 8px;
  }

  .card-container {
    background: ${({ theme }) => theme.card.bg.secondary};
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.card.border.quaternary};
    height: 100%;

    h2 {
      color: ${({ theme }) => theme.card.font.tertiary};
      font-size: 40px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .premium-plan-name {
      width: 100%;
      color: #048af5;
      font-size: 40px;
      font-weight: 500;
      margin-bottom: 20px;

      .trial {
        font-weight: 500;
        font-size: 18px;
      }
    }
  }

  .payment-method-container {
    border: 1px solid red;
    border-radius: 16px;
    border: 1px solid #0a0d121a;
    background-color: #fff;

    .header {
      padding: 20px 20px 16px;
      border-bottom: 1px solid #0a0d121a;
      margin-bottom: 0px;

      h1 {
        font-size: 14px;
        font-family: "Geist", sans-serif;
        font-weight: 500;
        color: #181d27;
        line-height: 20px;
        margin: 0;
      }
    }

    .plan-card-information {
      padding: 20px 20px 47px;

      .default-payment-card {
        display: flex;
        align-items: start;
        justify-content: space-between;
        background: #fafafa;
        padding: 20px 16px;
        border-radius: 8px;

        .card-wrapper {
          display: flex;
          align-items: start;
          gap: 1rem;

          .icon {
            border: 1px solid #e9eaeb;
            border-radius: 6px;

            img {
              height: 40px;
            }
          }

          .card-details {
            .ending {
              font-size: 14px;
              font-weight: 500;
              color: #414651;

              .brand {
                text-transform: capitalize;
              }
            }

            .date {
              font-size: 14px;
              color: #535862;
              font-family: "Public Sans", sans-serif;
              font-weight: 400;
            }

            .email-wrapper {
              display: flex;
              align-items: center;
              gap: 6px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }

  .premium {
    border: 1px solid rgba(10, 13, 18, 0.1);

    h2 {
      color: #048af5;
    }

    .price-wrapper {
      .trial-details {
        font-size: 16px;
        font-weight: 500;
        color: ${({ theme }) => theme.card.font.tertiary};
      }
    }
  }

  .plan-header {
    width: 100%;
    padding: 5px 12px;
    color: ${({ theme }) => theme.card.color.secondary};
    background-color: ${({ theme }) => theme.button.bg.primary};
    border-top-right-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
    border-top-left-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
  }

  @media (max-width: 768px) {
    .main-card {
      margin-bottom: 20px;
    }
    .default-payment-card {
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;
    }
    .card-wrapper {
      flex-direction: column;
      align-items: center !important;
      gap: 8px;
    }

    .plan-name {
      padding: 1.5rem;
      font-size: 18px;
    }

    .card-container .plan-card-information {
      .card-wrapper {
        margin-bottom: 10px;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      }
    }
  }
`;

export const FreePlanCardContainer = styled.div`
  height: 100%;

  .plan-details {
    width: 100%;
    min-height: 200px;
    position: relative;
    color: ${({ theme }) => theme.global.extraInfo.font.primary};
    border-bottom-left-radius: ${({ theme }) =>
      theme.constants.BORDER_RADIUS_8};
    border-bottom-right-radius: ${({ theme }) =>
      theme.constants.BORDER_RADIUS_8};

    .plan-information {
      h4 {
        font-weight: 700;
        margin-bottom: 1.2rem;
      }

      .price-divider {
        margin: 5px;
      }

      .line-through {
        position: relative;
        display: inline-block;
      }

      .line-through::after {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 1.5px;
        background-color: ${({ theme }) => theme.global.extraInfo.font.color};
        transform: rotate(-50deg);
        transform-origin: 50% 50%;
      }

      .amount-wrapper {
        font-size: 28px;
        font-weight: 600;
        color: ${({ theme }) => theme.global.extraInfo.font.color};
        margin-bottom: 0;

        .duration {
          font-size: 12px;
          font-weight: 400;
          vertical-align: middle;
          display: inline-block;
          margin-left: 4px;
        }
      }

      .benefit {
        font-weight: 400;
        font-size: 12px;
        line-height: 25px;
        margin-top: 8px;
      }

      ul {
        list-style: none;
        padding-left: 0;
        margin-bottom: 12px;

        li {
          font-weight: 400;
          font-size: 15px;
          line-height: 25px;
          color: ${({ theme }) => theme.card.font.tertiary};

          &:before {
            content: "✓";
            color: #048af5;
            font-weight: 800;
            margin-right: 10px;
          }
        }
      }

      .btn-change-plan {
        width: 100%;
      }

      .billing-date {
        font-size: 12px;
        margin: 12px 0;
      }

      .cancel-premium {
        cursor: pointer;
        color: #ff3f3f;
        font-size: 14px;
        margin-top: 10px;
      }
    }

    .divider {
      border: 1px solid ${({ theme }) => theme.divider.bg.secondary};
    }
  }

  .switch-to-free-btn {
    width: 100%;
    height: calc(100% - 300px);
    max-height: 80%;
    align-items: flex-end;
    display: flex;

    button {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .plan-details {
      .plan-information {
        padding: 0;

        .row {
          gap: 15px;

          h4 {
            font-size: 18px;
          }
        }
      }
    }
  }
`;

export const MailIcon = styled(Mail)`
  width: 16px;
  height: 16px;
  color: #a4a7ae;
`;
